(function() {
    'use strict';
    
a3_cabin_reports.factory('SpecialMealSourceFactory', SpecialMealSourceFactory);
    /**
    * @memberof CabinReports
    * @ngdoc factory
    * @name SpecialMealSourceFactory
    * @description 
    *   Manage Report's SpecialMealSources.
    * @ngInject
    */
function SpecialMealSourceFactory(GenericValuesFactory) {

        /**
         * Initialiaze SpecialMealSource object 
         * @memberof SpecialMealSourceFactory
         */
		function SpecialMealSource() {
			this.Code = null;
		}
	 
		var callback=SpecialMealSource;
		var type ='specialMealSources';
		
		var service = {
			fromObject : fromObject,
			fromObjectList : fromObjectList,
			toObjectList : toObjectList,
			getSpecialMealSourcesFromStorage : getSpecialMealSourcesFromStorage,
			getSpecialMealSourcesFromStorageAsStrings : getSpecialMealSourcesFromStorageAsStrings,
			setSpecialMealSourcesToStorage : setSpecialMealSourcesToStorage
		}
        
        /**
         * Create a new SpecialMealSource object 
         * @memberof SpecialMealSourceFactory
         * @returns {object} SpecialMealSource
         */	
		function fromObject(obj) {
			return GenericValuesFactory.fromObject(obj,callback);
		}

        /**
         * Extend given SpecialMealSource object List 
         * @memberof SpecialMealSourceFactory
         * @param {object} obj The SpecialMealSource object that will be extended
         * @returns {array} SpecialMealSources
         */  
		function fromObjectList(objList) {
			return GenericValuesFactory.fromObjectList(objList,callback);
		}
    
         /**
         * Get all the SpecialMealSource's Code from given list
         * @memberof SpecialMealSourceFactory
         * @param {array} objectList An object list
         * @returns {array} SpecialMealSources
         */
		function toObjectList(objList) {
			return GenericValuesFactory.objList(objList);
		}

        /**
         * Get all the SpecialMealSource objects
         * @memberof SpecialMealSourceFactory
         * @returns {array} SpecialMealSources
         */
		function getSpecialMealSourcesFromStorage() {
			return GenericValuesFactory.getValuesFromStorage(callback,type);
		}

        /**
         * Get all the SpecialMealSource's codes
         * @memberof SpecialMealSourceFactory
         * @returns {array} SpecialMealSources
         */
		function getSpecialMealSourcesFromStorageAsStrings() {
			return GenericValuesFactory.getValuesFromStorageAsStrings(callback,type);
		}

        /**
         * Set all the SpecialMealSources
         * @memberof SpecialMealSourceFactory
         * @param {array} objects A list of SpecialMealSources.
         */
		function setSpecialMealSourcesToStorage(objList) {
			GenericValuesFactory.setValuesToStorage(objList,type);
		}

	return service;
	}

})();
